<template>
    <div style="margin-right: 3px;">
        <svg
            width="12"
            height="10"
            viewBox="0 0 12 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M6 6L0.803849 0.749999L11.1962 0.75L6 6Z" fill="#899BAD" />
        </svg>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>